import { Divider, Flex, Typography } from 'antd';
import type { IDocumentFormatted } from 'queries/applications/useApplicationByReferenceNumber/types';
import { DocumentSourceEnum, DocumentTypeEnum } from '../../../legacy/shared-types';
import { CustomerFilesListItem } from './CustomerFilesListItem';

export interface ICustomerFilesListProps {
  documents?: IDocumentFormatted[];
}

const MOCK_CUSTOMER_FILE: IDocumentFormatted = {
  id: 1,
  applicationId: 1,
  originalFileName: 'bank-statement-jan-2025.pdf',
  type: DocumentTypeEnum.BANK_STATEMENT,
  source: DocumentSourceEnum.INTERNAL,
  createdAt: new Date('2025-01-15T10:30:00'),
  createdAtFormatted: '15/01/2025 10:30',
  deletedAt: null,
  description: null,
  url: '',
};

export const CustomerFilesList = ({ documents }: ICustomerFilesListProps) => {
  const list = documents?.length ? documents : [MOCK_CUSTOMER_FILE];

  return (
    <div className='w-full rounded-2xl bg-white'>
      <div className='px-6 py-3'>
        <Typography.Text className='mb-0 text-lg font-bold leading-8'>Customer files</Typography.Text>
      </div>
      <Divider className='my-0' />
      <div className='p-6'>
        <Flex vertical className='w-full gap-2'>
          {list.map(doc => (
            <CustomerFilesListItem key={doc.id} document={doc} />
          ))}
        </Flex>
      </div>
    </div>
  );
};
